import BaseRequestError from '@/components/BaseRequestError';

export default [
  {
    path: '/erro-de-solicitacao',
    name: 'request-error',
    meta: {
      showSidebar: false,
    },
    component: BaseRequestError,
    props: true,
  },
  {
    path: '*',
    name: 'page-not-found',
    meta: {
      showSidebar: false,
    },
    component: BaseRequestError,
    props: {
      message: {
        code: 404,
        text: 'Esta página não foi encontrada :(',
        icon: require('@/assets/img-notfound.svg',),
      },
    },
  },
];
